import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { breakpointSizes } from 'theme';

interface Props {
  children?: React.ReactNode;
}

/**
 * Media query components based on our breakpoints
 */

export function XLargeAndAbove({ children }: Props) {
  const isXLargeAndAbove = useMediaQuery({ minWidth: breakpointSizes.xl });
  return isXLargeAndAbove ? <>{children}</> : null;
}

export function LargeAndAbove({ children }: Props) {
  const isLargeAndAbove = useMediaQuery({ minWidth: breakpointSizes.lg });
  return isLargeAndAbove ? <>{children}</> : null;
}

export function MediumAndAbove({ children }: Props) {
  const isMediumAndAbove = useMediaQuery({ minWidth: breakpointSizes.md });
  return isMediumAndAbove ? <>{children}</> : null;
}

export function SmallAndBelow({ children }: Props) {
  const isSmallAndBelow = useMediaQuery({ maxWidth: breakpointSizes.md - 1 });
  return isSmallAndBelow ? <>{children}</> : null;
}
